'use strict';

angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.NewFromActionController', [
	'mx.SolutionBuilderAgent.DialogOpenerService',
	function newFromActionController(dialogOpener) {
		const vm = this;

		vm.execute = function (selectedObjects, action, presetFields, parentView) {
			const objectType = getQueryVariable(action.controllerParams, 'objectType');

			if (objectType === null || objectType === '') {
				throw new Error("Action Create Object: does not contain parameter 'objectType'");
			}
			let outerContext;
			if (action) {
				outerContext = Array.isArray(selectedObjects) && selectedObjects.length === 1 ? selectedObjects[0] : selectedObjects;
			}
			return dialogOpener
				.openNewDialog(objectType, action, selectedObjects, true, presetFields, parentView, undefined, outerContext)
				.newDialogOpenedPromise.then(function (view) {
					return {
						view: view,
					};
				})
				.catch(mx.logCatch);
		};

		function getQueryVariable(query, variable) {
			const vars = query.split('&');

			for (let i = 0; i < vars.length; i++) {
				const pair = vars[i].split('=');

				if (decodeURIComponent(pair[0]) === variable) {
					return decodeURIComponent(pair[1]);
				}
			}
		}
	},
]);
